<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Settings">
	<div class="settings-v2">
		<div class="v2-list-body settings-v2-body">
			<p class="settings-v2-locked-caption" *ngIf="locked$ | async">
				{{ "SETTINGS__SOME_LOCKED_BY_ORGANISATION" | transloco }}
			</p>

			<section class="settings-v2-section">
				<h3 class="settings-v2-section-title">{{ "SETTINGS__SECTION_FUNCTIONAL" | transloco }}</h3>

				<div
					class="settings-v2-row settings-v2-row--toggle"
					*ngIf="(isV2Available$ | async) && (rideOpsUi.isV2Active$ | async)"
				>
					<span class="settings-v2-row-label">{{ "SETTINGS__UNDO_LAST_DISPATCH" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setDispatchUndoOptIn($event)"
							[checked]="dispatchUndoOptIn$ | async"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle">
					<span class="settings-v2-row-label">{{ "SETTINGS__INPUT_CYCLES_AT_CLOSE" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setInputCyclesOnClose($event)"
							[checked]="allowChangingDispatchesWhenClosingLocation$ | async"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle">
					<span class="settings-v2-row-label">{{ "SETTINGS__INPUT_RIDERS_AT_CLOSE" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setInputRidersOnClose($event)"
							[checked]="allowChangingRidersWhenClosingLocation$ | async"
						></ion-toggle>
					</span>
				</div>
			</section>

			<section class="settings-v2-section">
				<h3 class="settings-v2-section-title">{{ "SETTINGS__SECTION_DASHBOARD" | transloco }}</h3>

				<div class="settings-v2-row settings-v2-row--toggle" *ngIf="bulletinWidgetEnabled$ | async">
					<span class="settings-v2-row-text">
						<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_BULLETIN_WIDGET" | transloco }}</span>
						<span class="settings-v2-row-value" *ngIf="(bulletinHasContent$ | async) !== true">
							{{ "SETTINGS__BULLETIN_WIDGET_CONTENT_HINT" | transloco }}
						</span>
					</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setWidgetVisibility($event, 'bulletinWidget')"
							[checked]="(widgetOptions$ | async).bulletinWidget?.visible"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle">
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_QUEUE_TIME_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setQueueWidgetVisibility($event)"
							[checked]="(widgetOptions$ | async).queueTime.visible"
						></ion-toggle>
					</span>
				</div>

				<div
					class="settings-v2-row settings-v2-row--toggle"
					*ngIf="allowStatisticsForOperator$ | async"
				>
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_DISPATCH_STATISTICS_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setWidgetVisibility($event, 'dispatchStatistics')"
							[checked]="(widgetOptions$ | async).dispatchStatistics?.visible"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle" *ngIf="assetDispatchQueueEnabled$ | async">
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_UNIT_LIST_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setWidgetVisibility($event, 'unitList')"
							[checked]="(widgetOptions$ | async).unitList?.visible"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle">
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_RIDERS_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setRidersWidgetVisibility($event)"
							[checked]="(widgetOptions$ | async).riders.visible"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle" *ngIf="safariAiEnabled$ | async">
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_SAFARI_AI_DISPATCH_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setWidgetVisibility($event, 'safariAiDispatch')"
							[checked]="(widgetOptions$ | async).safariAiDispatch?.visible"
						></ion-toggle>
					</span>
				</div>

				<div class="settings-v2-row settings-v2-row--toggle" *ngIf="safariAiEnabled$ | async">
					<span class="settings-v2-row-label">{{ "SETTINGS__SHOW_SAFARI_AI_QUEUE_WIDGET" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="locked$ | async"
							(ionChange)="setWidgetVisibility($event, 'safariAiQueue')"
							[checked]="(widgetOptions$ | async).safariAiQueue?.visible"
						></ion-toggle>
					</span>
				</div>
			</section>

			<section class="settings-v2-section">
				<h3 class="settings-v2-section-title">{{ "SETTINGS__SECTION_APP" | transloco }}</h3>

				<div class="settings-v2-row settings-v2-row--toggle" *ngIf="isV2Available$ | async">
					<span class="settings-v2-row-label">{{ "SETTINGS__RIDEOPS_V2_UI" | transloco }}</span>
					<span class="settings-v2-switch">
						<span
							*ngIf="locked$ | async"
							class="material-symbols-outlined settings-v2-lock-icon"
							aria-hidden="true"
						>
							lock
						</span>
						<ion-toggle
							mode="ios"
							[disabled]="v2ToggleDisabled$ | async"
							(ionChange)="setRideOpsUiV2OptIn($event)"
							[checked]="v2ToggleChecked$ | async"
						></ion-toggle>
					</span>
				</div>

				<button type="button" class="settings-v2-row settings-v2-row--nav" (click)="changeLanguage()">
					<span class="settings-v2-row-text">
						<span class="settings-v2-row-label">{{ "SETTINGS__LANGUAGE" | transloco }}</span>
						<span class="settings-v2-row-value">{{ currentLanguage$ | async }}</span>
					</span>
					<span
						class="material-symbols-outlined material-symbols-outlined--size-24 settings-v2-chevron"
						aria-hidden="true"
					>
						chevron_right
					</span>
				</button>

				<button type="button" class="settings-v2-row settings-v2-row--nav" (click)="changeLocation()">
					<span class="settings-v2-row-text">
						<span class="settings-v2-row-label">{{ "SETTINGS__CHANGE_LOCATION" | transloco }}</span>
						<span class="settings-v2-row-value" *ngIf="locationName$ | async as locationName">
							{{ locationName }}
						</span>
					</span>
					<span
						class="material-symbols-outlined material-symbols-outlined--size-24 settings-v2-chevron"
						aria-hidden="true"
					>
						chevron_right
					</span>
				</button>

				<button type="button" class="settings-v2-row settings-v2-row--nav" (click)="changePin()">
					<span class="settings-v2-row-text">
						<span class="settings-v2-row-label">{{ "SETTINGS__CHANGE_PIN" | transloco }}</span>
					</span>
					<span
						class="material-symbols-outlined material-symbols-outlined--size-24 settings-v2-chevron"
						aria-hidden="true"
					>
						chevron_right
					</span>
				</button>

				<button
					type="button"
					class="settings-v2-factory-reset"
					*ngIf="(locked$ | async) === false"
					(click)="factoryReset()"
				>
					{{ "SETTINGS__FACTORY_RESET" | transloco }}
				</button>
			</section>
		</div>
	</div>
</ng-container>

<ng-template #v1Settings>
	<ion-list>
		<ion-item (click)="changeLanguage()">
			<ion-label>{{ "SETTINGS__LANGUAGE" | transloco }}</ion-label>
			<ion-note slot="end">{{ currentLanguage$ | async }}</ion-note>
		</ion-item>

		<ion-item (click)="setDashboardStatistics()" *ngIf="allowStatisticsForOperator$ | async">
			<ion-label>{{ "SETTINGS__DASHBOARD_STATISTICS" | transloco }}</ion-label>
			<ion-note slot="end">{{ dashboardStatisticsMetricName$ | async }}</ion-note>
		</ion-item>

		<ion-item *ngIf="isV2Available$ | async">
			<ion-toggle
				[disabled]="v2ToggleDisabled$ | async"
				(ionChange)="setRideOpsUiV2OptIn($event)"
				[checked]="v2ToggleChecked$ | async"
			>
				{{ "SETTINGS__RIDEOPS_V2_UI" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item *ngIf="bulletinWidgetEnabled$ | async">
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setWidgetVisibility($event, 'bulletinWidget')"
				[checked]="(widgetOptions$ | async).bulletinWidget?.visible"
			>
				{{ "SETTINGS__SHOW_BULLETIN_WIDGET" | transloco }}
			</ion-toggle>
			<ion-note slot="helper" *ngIf="(bulletinHasContent$ | async) !== true">
				{{ "SETTINGS__BULLETIN_WIDGET_CONTENT_HINT" | transloco }}
			</ion-note>
		</ion-item>

		<ion-item>
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setRidersWidgetVisibility($event)"
				[checked]="(widgetOptions$ | async).riders.visible"
			>
				{{ "SETTINGS__SHOW_RIDERS_WIDGET" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item>
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setQueueWidgetVisibility($event)"
				[checked]="(widgetOptions$ | async).queueTime.visible"
			>
				{{ "SETTINGS__SHOW_QUEUE_TIME_WIDGET" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item *ngIf="safariAiEnabled$ | async">
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setWidgetVisibility($event, 'safariAiDispatch')"
				[checked]="(widgetOptions$ | async).safariAiDispatch?.visible"
			>
				{{ "SETTINGS__SHOW_SAFARI_AI_DISPATCH_WIDGET" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item *ngIf="safariAiEnabled$ | async">
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setWidgetVisibility($event, 'safariAiQueue')"
				[checked]="(widgetOptions$ | async).safariAiQueue?.visible"
			>
				{{ "SETTINGS__SHOW_SAFARI_AI_QUEUE_WIDGET" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item *ngIf="assetDispatchQueueEnabled$ | async">
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setWidgetVisibility($event, 'unitList')"
				[checked]="(widgetOptions$ | async).unitList?.visible"
			>
				{{ "SETTINGS__SHOW_UNIT_LIST_WIDGET" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item>
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setInputCyclesOnClose($event)"
				[checked]="allowChangingDispatchesWhenClosingLocation$ | async"
			>
				{{ "SETTINGS__INPUT_CYCLES_AT_CLOSE" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item>
			<ion-toggle
				[disabled]="locked$ | async"
				(ionChange)="setInputRidersOnClose($event)"
				[checked]="allowChangingRidersWhenClosingLocation$ | async"
			>
				{{ "SETTINGS__INPUT_RIDERS_AT_CLOSE" | transloco }}
			</ion-toggle>
		</ion-item>

		<ion-item>
			<ion-button style="width: 100%" (click)="changeLocation()" color="primary">
				{{ "SETTINGS__CHANGE_LOCATION" | transloco }}
			</ion-button>
		</ion-item>

		<ion-item>
			<ion-button style="width: 100%" (click)="changePin()" color="primary">
				{{ "SETTINGS__CHANGE_PIN" | transloco }}
			</ion-button>
		</ion-item>
	</ion-list>

	<ion-button
		*ngIf="(locked$ | async) === false"
		style="margin: 10px"
		expand="full"
		size="small"
		(click)="factoryReset()"
		color="warning"
	>
		{{ "SETTINGS__FACTORY_RESET" | transloco }}
	</ion-button>
</ng-template>
